import { render, staticRenderFns } from "./ResponseOptionFreeText.vue?vue&type=template&id=6db6a398&"
import script from "./ResponseOptionFreeText.vue?vue&type=script&lang=js&"
export * from "./ResponseOptionFreeText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports